export default __webpack_public_path__ + "static/media/ic_transfer_avax.53893264.svg";